var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.71429C0 1.99441 0.283147 1.30402 0.787151 0.794996C1.29116 0.285969 1.97473 0 2.6875 0H40.3125C41.0253 0 41.7088 0.285969 42.2129 0.794996C42.7169 1.30402 43 1.99441 43 2.71429C43 3.43416 42.7169 4.12455 42.2129 4.63357C41.7088 5.1426 41.0253 5.42857 40.3125 5.42857H2.6875C1.97473 5.42857 1.29116 5.1426 0.787151 4.63357C0.283147 4.12455 0 3.43416 0 2.71429ZM0 19C0 18.2801 0.283147 17.5897 0.787151 17.0807C1.29116 16.5717 1.97473 16.2857 2.6875 16.2857H40.3125C41.0253 16.2857 41.7088 16.5717 42.2129 17.0807C42.7169 17.5897 43 18.2801 43 19C43 19.7199 42.7169 20.4103 42.2129 20.9193C41.7088 21.4283 41.0253 21.7143 40.3125 21.7143H2.6875C1.97473 21.7143 1.29116 21.4283 0.787151 20.9193C0.283147 20.4103 0 19.7199 0 19ZM2.6875 32.5714C1.97473 32.5714 1.29116 32.8574 0.787151 33.3664C0.283147 33.8754 0 34.5658 0 35.2857C0 36.0056 0.283147 36.696 0.787151 37.205C1.29116 37.714 1.97473 38 2.6875 38H40.3125C41.0253 38 41.7088 37.714 42.2129 37.205C42.7169 36.696 43 36.0056 43 35.2857C43 34.5658 42.7169 33.8754 42.2129 33.3664C41.7088 32.8574 41.0253 32.5714 40.3125 32.5714H2.6875Z",
    fill: "#2F91F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.e2ea606ebad7954474a09f7d3c32c792.svg";
export { ForwardRef as ReactComponent };